import type { SaveEnvelope } from "./schema.js";
import type { SaveMigration } from "./migrations.js";

export type SaveSlot = "a" | "b";

export interface SaveRepository {
  load(): Promise<SaveEnvelope | null>;
  save(data: SaveEnvelope): Promise<void>;
  loadBackup(): Promise<SaveEnvelope | null>;
  clear(): Promise<void>;
  export(): Promise<Blob>;
  import(blob: Blob): Promise<SaveEnvelope>;
  exportDiagnostics(): Promise<Blob>;
}

export interface SaveRepositoryOptions {
  readonly databaseName?: string;
  readonly maxImportBytes?: number;
  readonly migrations?: readonly SaveMigration[];
  readonly now?: () => Date;
}

export interface SaveRecoveryReport {
  readonly recoveredFromBackup: boolean;
  readonly activeSlot: SaveSlot | null;
  readonly backupSlot: SaveSlot | null;
  readonly activeError: string | null;
  readonly backupError: string | null;
}

export class SaveImportError extends Error {
  public constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "SaveImportError";
  }
}

export class SaveStorageError extends Error {
  public constructor(
    message: string,
    public readonly operation: "clear" | "export" | "import" | "load" | "save",
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = "SaveStorageError";
  }
}
